import CS from "../../../services/commonService";
import { useAddHelpTopic, useUpdateHelpTopic } from "../../../queryHooks";
import { addHelpTopicSchema } from "../../../validations";
import React, { useState, useEffect } from "react";
import Select from "react-dropdown";
import { useFormik } from "formik";
import { useStore } from "../../../zustand/store";
//  Component starts
const AddUpdate = ({ helpTopic, onCloseModal, role_id }) => {
	//	Pre-defined values
	const statusOptions = [
		{ value: 1, label: "Active" },
		{ value: 0, label: "Inactive" },
	];
	//	State values
	const setLoading = useStore((state) => state.setLoading);
	const [status, setStatus] = useState(
		statusOptions.find((option) => option.value === helpTopic.is_active) || {
			value: 1,
			label: "Active",
		}
	);

	//Defining state object for formik
	const [formData] = useState({
		name: helpTopic.name,
		role_id,
	});

	const { values, errors, handleChange, handleSubmit, touched } = useFormik({
		initialValues: formData,
		validationSchema: addHelpTopicSchema,
		onSubmit: (value) => {
			if (helpTopic.id) {
				updateHelpTopic({
					name: value.name?.trim(),
					is_active: status.value,
					id: helpTopic.id,
				});
				setLoading(true);
			} else {
				addHelpTopic({
					name: value.name?.trim(),
					role_id,
				});
				setLoading(true);
			}
		},
	});

	const {
		mutateAsync: addHelpTopic,
		error: errorAddHelpTopic,
		data: dataAddHelpTopic,
	} = useAddHelpTopic();

	useEffect(() => {
		if (dataAddHelpTopic) {
			setLoading(false);
			if (dataAddHelpTopic.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataAddHelpTopic.message);
			} else if (dataAddHelpTopic.status === "fail") {
				CS.showErrorMessage(dataAddHelpTopic.message);
			}
		}
	}, [dataAddHelpTopic]);

	useEffect(() => {
		if (errorAddHelpTopic) {
			setLoading(false);
			CS.showErrorMessage(errorAddHelpTopic.response?.data?.message);
		}
	}, [errorAddHelpTopic]);

	const {
		mutateAsync: updateHelpTopic,
		error: errorUpdateHelpTopic,
		data: dataUpdateHelpTopic,
	} = useUpdateHelpTopic();

	useEffect(() => {
		if (dataUpdateHelpTopic) {
			setLoading(false);
			if (dataUpdateHelpTopic.status === "success") {
				onCloseModal();
				CS.showSuccessMessage(dataUpdateHelpTopic.message);
			} else if (dataUpdateHelpTopic.status === "fail") {
				CS.showErrorMessage(dataUpdateHelpTopic.message);
			}
		}
	}, [dataUpdateHelpTopic]);

	useEffect(() => {
		if (errorUpdateHelpTopic) {
			setLoading(false);
			CS.showErrorMessage(errorUpdateHelpTopic.response?.data?.message);
		}
	}, [errorUpdateHelpTopic]);

	return (
		<div className="modal-content">
			<div className="modal-header">
				<h5 className="modal-title">
					{" "}
					{helpTopic.id ? "Update Help Topic" : "Add Help Topic"}
				</h5>
			</div>
			<div className="notification-form modal-body card profile-card password-modal">
				<div className="row">
					<div className="col-md-12">
						<form onSubmit={handleSubmit}>
							<div className="mb-md-4 mb-3">
								<div className="form-group mb-0">
									<label className="label xl-label">
										Topic name<sup className="text-danger">*</sup>
									</label>
									<div className="w-100 position-relative">
										<input
											className="form-control"
											type="text"
											name="name"
											placeholder="Topic name"
											value={values.name}
											onChange={handleChange}
										/>
										<div className="error-message-password">
											<span className="text-danger error-msg d-block mb-2">
												{errors.name && touched.name ? errors.name : null}
											</span>
										</div>
									</div>
								</div>
							</div>
							{helpTopic.id && (
								<div className="mb-md-4 mb-3">
									<div className="form-group mb-0">
										<label className="label xl-label">
											Status<sup className="text-danger">*</sup>
										</label>
										<div className="w-100 position-relative">
											<Select
												value={status}
												onChange={(option) => setStatus(option)}
												options={statusOptions}
											/>
										</div>
									</div>
								</div>
							)}
							<div className="mt-5 text-right">
								<button className="btn btn-primary" type="submit">
									{helpTopic.id ? "Update" : "Add"}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AddUpdate;
